import { useEffect, useRef } from 'react';

/**
 * 监听网络恢复事件。
 */
export function useNetworkChange(callback: () => void | Promise<void>) {
  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  useEffect(() => {
    const handleOnline = () => {
      void callbackRef.current();
    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, []);
}

/**
 * 监听页面切回前台，仅在 visible 时触发。
 */
export function useVisibilityChange(callback: () => void | Promise<void>) {
  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      void callbackRef.current();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}
